import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    // Load user data from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      // In production, load permissions from API
      setPermissions(["read:paints", "write:paints", "delete:paints", "manage:users"]);
    }
  }, []);

  const hasPermission = (permission) => {
    return permissions.includes(permission) || permissions.includes("*");
  };

  const hasAnyPermission = (requiredPermissions) => {
    return requiredPermissions.some((perm) => hasPermission(perm));
  };

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    // In production, fetch permissions from API based on user role
    setPermissions(["read:paints", "write:paints", "delete:paints", "manage:users"]);
  };

  const logout = () => {
    setUser(null);
    setPermissions([]);
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    localStorage.isAuthenticated = false;
  };

  const value = {
    user,
    permissions,
    hasPermission,
    hasAnyPermission,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
